<span
  class="company-tree-row__indent"
  [style.flex-basis.px]="indentWidth()"
></span>
@if (showRevealControl()) {
  <span
    class="company-tree-row__expand"
    aria-hidden="true"
    (click)="onReveal($event)"
  >
    <mat-icon svgIcon="more-horizontal"></mat-icon>
  </span>
} @else if (showHideControl()) {
  <span
    class="company-tree-row__expand"
    aria-hidden="true"
    (click)="onHide($event)"
  >
    <mat-icon
      class="company-tree-row__chevron company-tree-row__chevron--expanded"
      svgIcon="chevron-right"
    ></mat-icon>
  </span>
} @else if (showExpandControl()) {
  <span
    class="company-tree-row__expand"
    aria-hidden="true"
    (click)="onToggle($event)"
  >
    <mat-icon
      class="company-tree-row__chevron"
      [class.company-tree-row__chevron--expanded]="row().expanded"
      svgIcon="chevron-right"
    ></mat-icon>
  </span>
}
<div class="company-tree-row__content">
  <div class="company-tree-row__main">
    <initials-badge [name]="row().name" [size]="30"></initials-badge>
    <div class="company-tree-row__text">
      <a class="company-tree-row__name" [attr.href]="href()" tabindex="-1">{{
        row().name
      }}</a>
      @if (row().address; as address) {
        <div class="company-tree-row__address">{{ address }}</div>
      }
      @if (parentLine(); as line) {
        <div class="company-tree-row__parent">{{ line }}</div>
      }
    </div>
  </div>
  <div class="company-tree-row__indicator">
    @if (showError()) {
      <span class="company-tree-row__error">{{ row().errorMessage }}</span>
      <span class="company-tree-row__retry" (click)="onRetry($event)"
        >Retry<span class="company-tree-row__retry-hint" aria-hidden="true">
          (Alt+Enter)</span
        ></span
      >
    } @else if (showSpinner()) {
      <span class="company-tree-row__spinner" aria-hidden="true"></span>
    } @else if (showCheck()) {
      <mat-icon
        class="company-tree-row__check"
        svgIcon="check-filled"
        aria-hidden="true"
      ></mat-icon>
    } @else if (showDot()) {
      <span class="company-tree-row__dot" aria-hidden="true"></span>
    }
  </div>
</div>
